<template>
  <button type="button" class="toolbarBtn"
    :class="{active: active}"
    @mousedown.prevent
    @click.stop="onClick">
    <img src="~@/assets/img/CITEditor/strikethrough.svg" alt="strikethrough" title="strikethrough" />
  </button>
</template>

<script>
export default {
  name: 'Strikethrough',
  props: [
    'active',
    'tag'
  ],
  methods: {
    onClick () {
      document.execCommand('Strikethrough', false)
      setTimeout(() => {
        const active = this.checkTag()
        this.$emit('setActive', { name: 'Strikethrough', active: active })
        // this.convertElement()
      })
    },
    checkTag () {
      const selection = window.getSelection()
      const nodeName = selection.focusNode.parentNode.nodeName.toLowerCase()
      const isActive = this.tag.includes(nodeName)
      return isActive
    },
    // convert ELEMENT strike to s
    convertElement () {
      const citEditor = document.querySelectorAll('.citContents')
      if (citEditor.length > 0) {
        citEditor.forEach(function (x) {
          const strikes = x.querySelectorAll('strike')
          if (strikes.length > 0) {
            strikes.forEach(function (strike) {
              const s = document.createElement('s')
              s.innerHTML = strike.innerHTML
              strike.replaceWith(s)
            })
          }
        })
      }
    }
  }
}
</script>
